import React from "react";

import Background from "../../../assets/market/market-bg-03.png";
import Image from "../../../assets/market/market-02-choice-a.png";

import GamePageLayout from "../GamePageLayout";

const MarketPage6 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("clothes-1")}
    >
      으아...
      <br />
      좀 귀찮지만 제로웨이스트샵 도착!
      <br />
      그치만 쓰레기가
      <br />안 나오니 엄청 좋다.
    </GamePageLayout>
  );
};

export default MarketPage6;
